module.exports = __webpack_public_path__ + "img/确认收货.46cdef68.png";